import { Instance } from 'mobx-state-tree';
import { RouteStopSchedulingFailedDtoModelBase } from './RouteStopSchedulingFailedDtoModel.base';

/* The TypeScript type of an instance of RouteStopSchedulingFailedDtoModel */
export interface RouteStopSchedulingFailedDtoModelType extends Instance<typeof RouteStopSchedulingFailedDtoModel.Type> {}

/* A graphql query fragment builders for RouteStopSchedulingFailedDtoModel */
export {
  selectFromRouteStopSchedulingFailedDto,
  routeStopSchedulingFailedDtoModelPrimitives,
  RouteStopSchedulingFailedDtoModelSelector,
}
  from './RouteStopSchedulingFailedDtoModel.base';

/**
 * RouteStopSchedulingFailedDtoModel
 *
 * Route scheduling failed event
 */
export const RouteStopSchedulingFailedDtoModel = RouteStopSchedulingFailedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
